import { useLocation, useNavigate } from 'react-router-dom';
import { Home, ListTodo, PlusCircle } from 'lucide-react';
import { useTelegram } from '@/core/providers';

const navItems = [
  { path: '/feed', icon: Home, label: 'Home' },
  { path: '/create', icon: PlusCircle, label: 'Create' },
  { path: '/tasks', icon: ListTodo, label: 'Tasks' },
];

function BottomNav() {
  const location = useLocation();
  const navigate = useNavigate();
  const { hapticFeedback } = useTelegram();

  const handleNavigation = (path: string) => {
    hapticFeedback('selection');
    navigate(path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 z-30 border-t border-[var(--ff-border)] bg-[var(--ff-surface)] pb-[calc(env(safe-area-inset-bottom,0px)+10px)] shadow-[0_-2px_10px_rgba(0,0,0,0.06)]">
      <div className="mx-auto flex max-w-xl items-center justify-around px-3 py-2">
        {navItems.map(({ path, icon: Icon, label }) => {
          const isActive =
            location.pathname === path ||
            (path === '/feed' && location.pathname.startsWith('/feed')) ||
            (path === '/tasks' && location.pathname.startsWith('/tasks'));

          return (
            <button
              key={path}
              onClick={() => handleNavigation(path)}
              className="flex flex-1 flex-col items-center justify-center rounded-xl px-3 py-2.5 transition-all duration-150"
              aria-label={label}
            >
              <Icon
                size={24}
                strokeWidth={isActive ? 2.4 : 2}
                className={isActive ? 'text-[#0a84ff]' : 'text-[var(--ff-muted)]'}
              />
            </button>
          );
        })}
      </div>
    </nav>
  );
}

export default BottomNav;
